import Modal from './Modal'

/**
 * Generic "not enough stock" notice. Shown when a material deduction is refused
 * because the master `Materials.QuantityInStock` would go below 0. Used by the
 * household materials section (and, after the subtask retirement, anywhere that
 * deducts stock).
 */
const StockWarningModal = ({ modalOpen, setModalOpen, blockedBy }) => {
    const title = blockedBy?.Title || 'materiaal'
    const required = blockedBy?.Required ?? 0
    const available = blockedBy?.Available ?? 0

    const content = (
        <div className='subtask-stock-warning'>
            <p>
                Niet genoeg voorraad voor <strong>{title}</strong>.
            </p>
            <p>
                Nodig: {required} &middot; Beschikbaar: {available}
            </p>
            <p>
                Vul de voorraad aan via de pagina <strong>Materialen</strong> of verlaag het aantal.
            </p>
        </div>
    )

    return (
        <Modal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            pageHeader='Niet genoeg voorraad'
            content={content}
            hideConfirm={true}
            cancelLabel='Sluiten'
        />
    )
}

export default StockWarningModal
